const inputTextPasswordUtils = {
    eyeColorValidation : function ( id, value ) {
        if( value ) {
            document.getElementById( id ).nextElementSibling.lastElementChild.classList.add( 'eye-icon' )
        } else {
            document.getElementById( id ).nextElementSibling.lastElementChild.classList.remove( 'eye-icon' )
        }
    }
}

export default inputTextPasswordUtils